export default __webpack_public_path__ + "static/media/tansen-samaroh-brochure.da7acf23.jpg";